(function () {
  var loading = false;

  function getCartRecommendations() {
    var container = document.querySelector(
      '[data-fosie-cart-recommendations-container]'
    );

    if (!container || loading) return;

    loading = true;

    fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) {
          container.innerHTML = '';
          return null;
        }

        // カート内の先頭商品を基準に関連商品を取得
        var productId = cart.items[0].product_id;

        return fetch(
          '/recommendations/products?section_id=fosie-cart-recommendations&product_id=' +
            productId +
            '&limit=3&intent=related',
          {
            credentials: 'same-origin'
          }
        );
      })
      .then(function (response) {
        if (!response) return null;
        return response.text();
      })
      .then(function (html) {
        if (!html) return;

        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        var recommendations = wrapper.querySelector(
          '[data-fosie-cart-recommendations]'
        );

        if (recommendations) {
          container.innerHTML = recommendations.outerHTML;
        } else {
          container.innerHTML = '';
        }
      })
      .catch(function () {
        container.innerHTML = '';
      })
      .finally(function () {
        loading = false;
      });
  }

  // ページ初回表示
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      getCartRecommendations
    );
  } else {
    getCartRecommendations();
  }

  // 商品をカートへ追加
  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(getCartRecommendations, 300);
  });

  // カート内の数量変更・削除
  document.addEventListener('cart:updated', function () {
    setTimeout(getCartRecommendations, 150);
  });
})();